const KEYCODES =
{
    ARROW_DOWN: 40,
    ARROW_UP: 38,
    ENTER: 13,
    BACKSPACE: 8
}

export default { KEYCODES }


// WEBPACK FOOTER //
// ./src/utils/inputUtils.js